module.exports = __webpack_public_path__ + "img/586.d9340df2.jpg";